'use client';

import classNames from 'classnames';
import { useMemo } from 'react';

import { PropsWithClassname } from '@/app/types';

interface ProgressBarProps extends PropsWithClassname {
  total: number;
  currentValue: number;
  indicateFinishedWithPrimaryColor?: boolean;
}

const ProgressBar = ({ total, currentValue, indicateFinishedWithPrimaryColor, className }: ProgressBarProps) => {
  const percentageAchieved = useMemo(() => {
    return Math.min(currentValue / (total / 100), 100);
  }, [total, currentValue]);

  return (
    <div
      className={classNames(className, 'relative w-full h-[8px] rounded-[10px]', {
        'bg-success-light': percentageAchieved >= 100 && !indicateFinishedWithPrimaryColor,
        'bg-primary-light': percentageAchieved < 100 || indicateFinishedWithPrimaryColor,
      })}
    >
      <div
        className={classNames(
          `absolute top-0 left-0 max-w-full h-[8px] rounded-[10px] animate-[grow_2s_ease-in-out] origin-left`,
          {
            'bg-success-mid': percentageAchieved >= 100 && !indicateFinishedWithPrimaryColor,
            'bg-primary-mid': percentageAchieved < 100 || indicateFinishedWithPrimaryColor,
          },
        )}
        style={{
          right: `${100 - Math.floor(percentageAchieved)}%`,
        }}
      />
    </div>
  );
};

export default ProgressBar;
